import { isObservableArray } from "mobx";

// Only read the act's associations, never its owning musician's genres.
export const getActGenreNames = (act, catalog = []) => {
    const namesById = new Map(catalog.map(genre => [String(genre.id), genre.name]));
    const isList = value => Array.isArray(value) || isObservableArray(value);
    if (isList(act?.genres)) {
        return Array.from(new Set(act.genres.map(genre => genre?.name || namesById.get(String(genre?.id))).filter(Boolean)));
    }
    if (isList(act?.genreIds)) {
        const names = act.genreIds.map(id => namesById.get(String(id))).filter(Boolean);
        if (names.length || !act.genresName) return Array.from(new Set(names));
    }
    if (act?.genresName) return Array.from(new Set(act.genresName.split(",").map(name => name.trim()).filter(Boolean)));
    const associations = Array.isArray(act?.profileGenres) || isObservableArray(act?.profileGenres) ? act.profileGenres : [];
    return associations.map(association => {
        const id = association?.genreId != null ? association.genreId : association?.genre?.id;
        return association?.genre?.name || association?.name || (id != null ? namesById.get(String(id)) : undefined);
    }).filter(Boolean);
};

export const getCatalogGenreNames = catalog =>
    Array.from(new Set(catalog.map(genre => genre.name).filter(Boolean))).sort();
